<script>
	import Steps from '../Steps';
	import swal from 'sweetalert';
	import { mapMutations,mapState } from 'vuex';
	import {stepOneTarget} from '../../stepsTargets.js';

	export default{
		props:['terminatedTour'],
		components:{Steps},
		data(){
			return{
				steps: stepOneTarget,
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Siguiente'
					}
				},
			}
		},
		computed:{
			...mapState(['stepActive','stepOne','alertas','ejercicioActivo']),
			tipoSolicitud(){
				return this.stepOne.tipoSolicitud;
			},
			tipoSolicitudAcuerdo(){
				return this.stepOne.tipoSolicitudAcuerdo;
			},
		},
		watch: {
			terminatedTour(){
				if(this.alertas){
					this.$tours['stepOne'].start();	
				}
			},
			tipoSolicitud(){
				if(this.ejercicioActivo != 'evaluacion-1' && this.ejercicioActivo != 'evaluacion-2'){
					if(this.tipoSolicitud != 'Nueva Solicitud'){
						swal({title: "¡Atención!",text: 'Debes crear una nueva solicitud para este ejercicio.',icon: "error",button: 'Aceptar'}).
						then(() => {
							this.stepOne.tipoSolicitud = 'Nueva Solicitud';
						});
					}	
				}
				
			},
			tipoSolicitudAcuerdo(){
				if(this.ejercicioActivo != 'evaluacion-1' && this.ejercicioActivo != 'evaluacion-2'){
					if(this.tipoSolicitudAcuerdo != 'Volumen'){
						swal({title: "¡Atención!",text: 'El tipo de solicitud de este acuerdo debe ser "Volumen".',icon: "error",button: 'Aceptar'}).
						then(() => {
							this.stepOne.tipoSolicitudAcuerdo = 'Volumen';
						});
					}
				}
			}
		},
		methods:{
			...mapMutations(['changeStepActive','saveStepOne']),
			saveStep(stepC){
				if(this.tipoSolicitud != '' && this.tipoSolicitudAcuerdo){
					this.changeStepActive(stepC);
					this.saveStepOne(this.stepOne);
				}
			},
			restartTour(){
				this.$tours['stepOne'].start();
			},
			
		}
	}
</script>
<template>
	<div class="contenido">
		<v-tour name="stepOne" :steps="steps" :options="myOptions"/>
		<div class="header-tools">
			<div class="title">
				Crear Solicitud Acuerdo: Paso 1 (Tipo de Solicitud)
			</div>
			<div class="buttons">
				<div>
					<button disabled="" @click="changeStepActive()"> <i class="fas fa-chevron-left"></i> Atrás </button>
					<button data-v-step="5" @click="saveStep(stepActive+1)">Continuar <i class="fas fa-chevron-right"></i></button>
					| <button v-if="alertas" @click="restartTour()" class="btn-icon"><i class="fas fa-question-circle"></i> Instrucciones</button>
				</div>
			</div>
		</div>
		<steps :stepActive="stepActive"/>
		<hr class="separator-steps-content">
		<div>
			<div class="title-main-content">
				Seleccione Tipo de Solicitud
			</div>
			<div class="container-fluid">
				<div class="col-md-7">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<div class="radio">
									<label data-v-step="3">
										<input type="radio" v-model="stepOne.tipoSolicitud" name="typeRequest" checked value="Nueva Solicitud">Nueva Solicitud
									</label>
									<p>Crear una nueva aportación (fija/volumen compras)</p>
								</div>	
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<div class="radio">
									<label><input type="radio" v-model="stepOne.tipoSolicitud" name="typeRequest" value="Copiar Acuerdo">Copiar Acuerdo</label>
									<p>Copiar el acuerdo actual</p>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<div class="radio">
									<label>
										<input type="radio" v-model="stepOne.tipoSolicitud" name="typeRequest" value="Solicitud para Cambiar Acuerdo">Solicitud para Cambiar Acuerdo
									</label>
									<p>Hacer un cambio de acuerdo existente</p>
								</div>	
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<div class="radio">
									<label><input type="radio" v-model="stepOne.tipoSolicitud" name="typeRequest" value="Copiar Solicitud de Acuerdo">Copiar Solicitud de Acuerdo</label>
									<p>Copiar una solicitud de acuerdo existente</p>
								</div>
							</div>
						</div>
					</div>
					<div class="subtitle-content">
						Seleccione el Tipo de solicitud de acuerdo
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<div class="radio">
									<label data-v-step="4">
										<input type="radio" v-model="stepOne.tipoSolicitudAcuerdo" name="typeRequestAgreement" value="Volumen">Volumen
									</label>
									<p>Las Aportaciones de Volumen deben ser aprobadas por el comprador, el proveedor y 
										AR (o cualquier rol financiero equivalente) a más tardar a fin de mes y un máximo de 15 días después 
									de la fecha de inicio del acuerdo.</p>
								</div>	
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<div class="radio">
									<label><input type="radio" v-model="stepOne.tipoSolicitudAcuerdo" name="typeRequestAgreement" value="Fijo">Fijo</label>
									<p>Las aportaciones Fijas deben ser aprobadas a más tardar a fin de mes; es decir, 15 días 
										después de la fecha de finalización del acuerdo (30 días para mercado sin sistema). 
									Esto ayudará a garantizar que las aportaciones sean pagadas de manera</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>